import { render } from "./Remarks.vue?vue&type=template&id=6c092966&scoped=true&ts=true"
import script from "./Remarks.vue?vue&type=script&lang=ts"
export * from "./Remarks.vue?vue&type=script&lang=ts"

import "./Remarks.vue?vue&type=style&index=0&id=6c092966&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c092966"]])

export default __exports__